import { useEffect, useState } from 'react';

import { formatElapsed } from '../state/researchState';

/** The counter re-reads the clock this often (ms). */
export const ELAPSED_TICK_MS = 1000;

export interface ElapsedProps {
  /** Epoch ms to count from. */
  startedAt: number;
  /** Epoch ms to stop at; null keeps counting. */
  frozenAt: number | null;
  /** The test id of the text (several counters can be on one page). */
  testId?: string;
}

/**
 * The `m:ss` counter, as a leaf: it owns the one-second tick, so only this text re-renders each second and the
 * page, the transcript and the cards around it do not (TP's tick re-rendered the whole page). Frozen, it holds no timer.
 */
export function Elapsed({ startedAt, frozenAt, testId = 'research-elapsed' }: ElapsedProps) {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (frozenAt !== null) return;
    setNow(Date.now());
    const id = setInterval(() => setNow(Date.now()), ELAPSED_TICK_MS);
    return () => clearInterval(id);
  }, [frozenAt]);
  return <span data-testid={testId}>{formatElapsed((frozenAt ?? now) - startedAt)}</span>;
}
